import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";

function TradeFinance() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`
             <div style=" align-items: baseline;">
            Trade
                <span className="jumbotron-subtitle-2">
                 Finance
                    </span>
            </div>`}
          buttonText="Reach out to us!"
          // footNotes="Protected by PIDM up to RM250,000 for each depositor"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              In trading, it is essential for traders to collect their dues on
              time to pay suppliers. When your domestic goods are delivered
              promptly and your imported goods cleared quickly, good reputation
              and trust in your services and offerings is established. alrajhi
              bank Malaysia provides financing solutions to help you maximise
              your domestic and international trading potential, entitling you
              to peace of mind while managing your money, banking, credit,
              investments and assets. This also ensures your partners’ trust in
              your products and services.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default TradeFinance;
